import { render, staticRenderFns } from "./AddPolygon.vue?vue&type=template&id=fad0c0e0&scoped=true"
import script from "./AddPolygon.vue?vue&type=script&lang=ts"
export * from "./AddPolygon.vue?vue&type=script&lang=ts"
import style0 from "./AddPolygon.vue?vue&type=style&index=0&id=fad0c0e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad0c0e0",
  null
  
)

export default component.exports